import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  scrolled?: boolean;
}

export default function LanguageSwitcher({ scrolled = false }: LanguageSwitcherProps) {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const lang = i18n.language || 'es';

  return (
    <div className={`flex items-center rounded-full p-1 transition-colors ${scrolled ? 'bg-coffee-100' : 'bg-white/20 backdrop-blur-sm'}`}>
      <button
        onClick={() => changeLanguage('es')}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-all ${
          lang.startsWith('es')
            ? scrolled
              ? 'bg-coffee-400 text-white shadow-sm'
              : 'bg-coffee-300 text-coffee-900 shadow-sm'
            : scrolled
              ? 'text-coffee-700 hover:text-coffee-900'
              : 'text-white/80 hover:text-white'
        }`}
        aria-label="Switch to Spanish"
      >
        ES
      </button>
      <button
        onClick={() => changeLanguage('en')}
        className={`px-3 py-1 text-xs font-semibold rounded-full transition-all ${
          lang.startsWith('en')
            ? scrolled
              ? 'bg-coffee-400 text-white shadow-sm'
              : 'bg-coffee-300 text-coffee-900 shadow-sm'
            : scrolled
              ? 'text-coffee-700 hover:text-coffee-900'
              : 'text-white/80 hover:text-white'
        }`}
        aria-label="Switch to English"
      >
        EN
      </button>
    </div>
  );
}
